import { createFileRoute } from '@tanstack/react-router'

// /teams/$teamId — team selected, no report open. This is the URL of the NAV STACK's middle level: the team's
// members list, with the report one push further in (see nav-stack.tsx, and the depth derivation in
// teams.tsx). Making it a real route rather than a search-param flag is what lets the browser Back button pop
// the stack, keeps the level deep-linkable, and distinguishes "opened the team" from "asked for the team's own
// report" — two states that were the same URL before.
//
// It renders nothing into the report Outlet: on mobile that pane is off-stage, and on desktop it is the empty
// detail pane (the same shape `/offers/$offerId` has always had). The `teams.$teamId` layout above provides the
// `teamId` param and owns the chrome prefetch (getTeam + members list), so this leaf needs no loader of its own.
export const Route = createFileRoute('/_app/teams/$teamId/')({
  component: () => null,
})
